import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavDashboard({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 2.55a7 7 0 00-6.05 10.52c.14.23.4.37.67.37h10.76c.27 0 .53-.14.67-.37A7 7 0 008 2.55zm0 1.56c.36 0 .65.24.74.57-.03.06-.07.1-.09.16l-.22.68a.76.76 0 01-.43.14.78.78 0 010-1.55zm-4.67 7a.78.78 0 110-1.56.78.78 0 010 1.56zM4.5 7.2a.78.78 0 110-1.55.78.78 0 010 1.56zm6-1.75L9 9.93a1.55 1.55 0 01.34 1.95H6.66A1.54 1.54 0 017.9 9.56l1.5-4.47c.1-.3.42-.48.73-.37.3.1.47.43.37.74zm.35 1.39l.38-1.13a.77.77 0 01.27-.06.78.78 0 010 1.56.77.77 0 01-.65-.37zm1.82 4.26a.78.78 0 110-1.56.78.78 0 010 1.56z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNavDashboard.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavDashboard.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavDashboard svgRef={ref} {...props} />);
export default ForwardRef;
